<template>
    <div class="routing-list">
        <h1 class="view-title">
			NOVO ROTEIRO
            <a class="btn btn-link btn-right" :href="root_url + '/download/deliveryb2b_help.pdf'" target="_blank">
                <i class="fas fa-file-pdf"></i> ABRIR TUTORIAL
            </a>
		</h1>
        <div class="inner-content shadowed">
            <div class="row">
                <div class="col-xs-12 col-lg-12">
                    <div class="container-timeline" data-v-step-routing-form-step-1="0" data-v-step-routing-form-step-2="0" data-v-step-routing-form-step-3="0" data-v-step-routing-form-step-4="0">
                        <div class="row">
                            <div class="col-xs-12 col-lg-offset-3 col-lg-6">
                                <div class="row timeline">
                                    <div class="col-xs-12 col-lg-3 timeline-item">
                                        <div class="row" :class="'timeline-item-step ' + ((step >= 1) ? 'complete' : '')">
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-number">1</div>
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-label">Início</div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-lg-3 timeline-item">
                                        <div class="row" :class="'timeline-item-step ' + ((step >= 2) ? 'complete' : '')">
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-number">2</div>
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-label">Veículos</div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-lg-3 timeline-item">
                                        <div class="row" :class="'timeline-item-step ' + ((step >= 3) ? 'complete' : '')">
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-number">3</div>
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-label">Entregas</div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-lg-3 timeline-item">
                                        <div class="row" :class="'timeline-item-step ' + ((step >= 4) ? 'complete' : '')">
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-number">4</div>
                                            <div class="col-xs-12 col-lg-12 timeline-item-step-label">Roteirizar</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-lg-12" v-if="step == 1">
                    <div class="container-form">
                        <RoutingFormStep1 
                            :data="data[step]"
                            :my_dcs="my_dcs"
                            @next="nextStep"
                            @cancel="changeView"
                        />
                    </div>
                </div>
                <div class="col-xs-12 col-lg-12" v-if="step == 2">
                    <div class="container-form">
                        <RoutingFormStep2 
                            :data="data[step]"
                            :my_vehicles="my_vehicles" 
                            :selected="selected_list[step]"
                            :selected_return_origin="selected_list_return_origin"
                            :unselected_return_origin="unselected_list_return_origin"
                            :filter_fields="filter_fields_vehicle"
                            @previous="previousStep"
                            @next="nextStep"
                            @cancel="changeView" 
                        />
                    </div>
                </div>
                <div class="col-xs-12 col-lg-12" v-if="step == 3">
                    <div class="container-form">
                        <RoutingFormStep3 
                            :data="data[step]"
                            :my_customers="my_customers"
                            :my_documents="my_documents"
                            :my_drivers="my_drivers"
                            :selected="selected_list[step]"
                            :filter_fields="filter_fields_delivery"
                            :filter_options="filter_options_delivery"
                            :selected_weight_capacity="getWeightCapacity(data[2])"
                            :url_api_atak="my_settings.url_api_atak"
                            :default_customer_sync_name="my_settings.default_customer_sync_name"
                            :default_moviment_type_code="my_settings.default_moviment_type_code"
                            :routing_hash="routing_hash"
                            @previous="previousStep"
                            @next="nextStep"
                            @cancel="changeView"
                        />
                    </div>
                </div>
                <div class="col-xs-12 col-lg-12" v-if="step == 4">
                    <div class="container-form">
                        <RoutingFormStep4 
                            :data="data"
                            @loading="setLoading"
                            @update="updateStep"
                            @previous="previousStep"
                            @cancel="changeView"
                            @send="send"
                        />
                    </div>
                </div>
            </div>
            <transition name="loading-transition">
                <div v-if="loading" class="row">
                    <RoutingLoading  label="OTIMIZANDO CARGAS E ROTAS" />
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

import RoutingFormStep1 from "../Routing/RoutingFormStep1";
import RoutingFormStep2 from "../Routing/RoutingFormStep2";
import RoutingFormStep3 from "../Routing/RoutingFormStep3";
import RoutingFormStep4 from "../Routing/RoutingFormStep4";
import RoutingLoading from "../Routing/RoutingLoading";

export default {
    name: "RoutingForm",

    props: {
        my_customers: {
            type: Array,
            require: true,
        },
        my_dcs: {
            type: Array,
            require: true,
        },
        my_documents: {
            type: Array,
            require: true,
        },
        my_drivers: {
            type: Array,
            require: true,
        },
        my_settings: {
            type: Object,
            require: true,
        },
        my_vehicles: {
            type: Array,
            require: true,
        },
        routing_hash: {
            type: String,
            require: true,
        },
    },

    components: {
        RoutingFormStep1,
        RoutingFormStep2,
        RoutingFormStep3,
        RoutingFormStep4,
        RoutingLoading,
    },

    data: function() {
        return {
            root_url: this.$api.config.B2B_ROOT_URL,
            loading: false,
            step: 1,
            data: {
                1: {
                    name: "",
                    date: this.getFormattedCurrentDate(),
                    min: this.getFormattedCurrentDate(),
                    start_time: (this.my_settings.start_time !== undefined) ? this.my_settings.start_time : "00:00",
                    end_time: (this.my_settings.end_time !== undefined) ? this.my_settings.end_time : "00:00",
                    start_lunch_time: (this.my_settings.start_lunch_time !== undefined) ? this.my_settings.start_lunch_time : 0,
                    end_lunch_time: (this.my_settings.end_lunch_time !== undefined) ? this.my_settings.end_lunch_time : 0,
                    average_speed: (this.my_settings.average_speed !== undefined) ? this.my_settings.average_speed : 0,
                    discharge_weight_per_minut: (this.my_settings.discharge_weight_per_minut !== undefined) ? this.my_settings.discharge_weight_per_minut : 0,
                    average_discharge_time: (this.my_settings.average_discharge_time !== undefined) ? this.my_settings.average_discharge_time : 0,
                    correction_fact: (this.my_settings.correction_fact !== undefined) ? parseInt(this.my_settings.correction_fact) : 100,
                    distribution_center: "",
                    weight_constraints: true,
                    time_constraints: true,
                    company_branch_code: "",
                },
                2: [],
                3: [],
                4: []
            },
            selected_list: {
                2: [],
                3: [],
            },
            selected_list_return_origin: [],
            unselected_list_return_origin: [],
            selected_weight_capacity: 0.0,
            selected_weight: 0.0,

            filter_fields_vehicle: {
                license_plate: [],
                brand: [],
                vehicle_type: [],
                bodywork: [],
                model: "",
                weight_capacity: "",
                expanded_center: "",
                rotation_day: "",
            },
            filter_fields_delivery: {
                start: this.getFormattedCurrentDate(),
                end: this.getFormattedCurrentDate(),
                type: (this.my_settings.show_delivery_type !== undefined) ? this.my_settings.show_delivery_type != "A" ? [this.my_settings.show_delivery_type] : [] : [],
                
                show_complete_inputs: false,
                company_document: [],
                customer: [],
                dc: [],
                document_number: "",
                postal_code: "",
                street: "",
                neighborhood: "",
                city: [],
                cities_list: [],
                uf: [],
                zone: [],
                course: [],
                temperature: [],
                bone: [],
                no_weight_zero: false,
                order: "document_number-ASC",
                page: 0,
                per_page: 50,
            },
            filter_options_delivery: {
                documents: {},
                customers: {},
                dcs: {},
                cities: {},
                ufs: {},
                zones: {},
            }
        }
    },
    
    methods: {
        /**
         * Obtém a data atual formatada
         * @return {string} data formatada
         */
        getFormattedCurrentDate: function() {
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0');
            let yyyy = today.getFullYear();
            
            return yyyy + '-' + mm + '-' + dd;
        },
        
        /**
         * Obtem a capacidade somada
         * @param {array} list array das informações de capacidade
         * @return {float} capacidade somada
         */
        getWeightCapacity: function(list) {
            let weight = 0.0;

            list.forEach(element => {
                if (element.weight_capacity) weight += element.weight_capacity;
            });

            return weight;
        },
        
        /**
         * Salva as informações da última etapa
         * @param {object} data objeto com as informações da etapa
         */
        updateStep: async function(data) {
            this.data[this.step] = data;
            await this.removeAllSelectedDeliveries();
        },
        
        /**
         * Volta um passo
         */
        previousStep: function() {
            this.step--;
        },
        
        /**
         * Salva as informações da etapa anterior e avança uma etapa
         * @param {object} result 
         */
        nextStep: function(result) {
            this.data[this.step] = result;
            this.step++;
        },
        
        /**
         * Define as informações com as informações da etapa 4 e muda a view
         * @param {string} view 
         */
        send: function(view) {
            this.$emit("update", this.data[4]);
            this.$emit("view", view);
        },
        
        /**
         * Muda o status de carregamento
         * @param {boolean} value 
         */
        setLoading: function(value) {
            this.loading = value;
        },
        
        /**
         * Muda a view para o form de roteiro
         */
        changeView: async function() {
            // Apresenta a confirmação
            let confirm = await this.$alert.confirm("Deseja mesmo cancelar?", "CANCELAR");

            // Verifica se para remover
            if(!confirm) return;

            await this.removeAllSelectedDeliveries();

            this.$emit('view', 'list');
        },

        /**
         * Remove todas os registros de entregas selecionadas armazenados com o hash de roteirização
         */
        removeAllSelectedDeliveries: async function() {
            let result = null;

			try {
				result = await Api.post("delivery-routing/remove-all-selected-deliveries", {
                    routing_hash: this.routing_hash
                });
			} catch(ex) {
				console.log(ex);
                this.$notification.error("Não foi possível remover todas as informações armazenadas.");
				return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					console.log(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível remover todas as informações armazenadas.");
				return;
			}
        },
    }
}
</script>

<style scoped>
.container-timeline {
    padding: 15px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    background-color: #fff;
}
.container-form {
    background-color: #fff;
}

div.timeline {
    display: flex;
    align-items: center;
    justify-content: center;
}

div.timeline > div.timeline-item {
    margin-top: 15px;
}

div.timeline > div.timeline-item > div.timeline-item-step {
    position: relative;
    text-align: center;
}

div.timeline > div.timeline-item:not(:first-child) > div.timeline-item-step::before {
    content: "";
    position: absolute;
    margin: auto;
    top: 25px;
    right: 50%;
    width: 100%;
    border-top: 2px dashed #ddd;
    z-index: 0;
}

div.timeline > div.timeline-item:not(:first-child) > div.timeline-item-step.complete::before {
    border-top: 2px solid #595959;
}

div.timeline > div.timeline-item > div.timeline-item-step::after {
    content: "";
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    width: 50px;
    height: 50px;
    border: 2px solid #ddd;
    border-radius: 5px;
    background-color: #ddd;
    z-index: 1;
}

div.timeline > div.timeline-item > div.timeline-item-step.complete::after {
    content: "";
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    width: 50px;
    height: 50px;
    border: 2px solid #fff;
    border-radius: 5px;
    background-color: #595959;
    z-index: 1;
}

div.timeline > div.timeline-item > div.timeline-item-step > div.timeline-item-step-number {
    margin: 0px 0px 15px;
    line-height: 50px;
    z-index: 2;
}

div.timeline > div.timeline-item > div.timeline-item-step.complete > div.timeline-item-step-number {
    color: #fff;
}

div.timeline > div.timeline-item > div.timeline-item-step > div.timeline-item-step-label {
    margin: 0px 0px 15px;
    z-index: 2;
}

.loading-transition-enter,
.loading-transition-leave-active {
  opacity: 0;
}

/*.loading-transition-enter-active,
.loading-transition-leave-active {
  transition: opacity 0.4s;
}*/

</style>